import { render } from "./Dashboard.vue?vue&type=template&id=7c0301fe"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=7c0301fe&lang=css"
script.render = render

export default script